import { useConfigStore } from "@/stores/config";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { STRUCTURE_UNIT_TYPE } from "@/constants/Inspections";
import { useNotesStore } from "@/components/inspection/store/notes";

export default function useNotesData() {
  const configStore = useConfigStore();
  const inspectionStore = useInspectionStore();
  const notesStore = useNotesStore();

  function noteTypeIN01(commentType) {
    return configStore.getReferenceValue(REFERENCE_TABLE.INSPECTION_COMMENT_TYPE, commentType, false, true);
  }

  function substuctureUnitIN03(structureUnitId) {
    const structureUnitLocations = notesStore.convertStructureUnitsToLocationsNotes(
      inspectionStore.getFilteredStructureUnits(
        [
          STRUCTURE_UNIT_TYPE.PIER,
          STRUCTURE_UNIT_TYPE.ABUTMENT,
          STRUCTURE_UNIT_TYPE.APPROACH,
          STRUCTURE_UNIT_TYPE.MAIN,
          STRUCTURE_UNIT_TYPE.CULVERT,
        ],
        true
      )
    );
    return structureUnitLocations?.find((strUnitLocation) => strUnitLocation.value == structureUnitId)?.title;
  }
  const parseStrUnitLabel = (label) => {
    const index = [...label]?.findIndex((char) => !Number.isNaN(Number(char)));

    if (index === -1) {
      return { prefix: label, number: Infinity };
    }

    return {
      prefix: label?.slice(0, index),
      number: Number(label?.slice(index)),
    };
  };

  function noteTypeIN04(commentType) {
    return configStore.getReferenceValue(REFERENCE_TABLE.SUBSTRUCTURE_COMMENT_TYPE, commentType);
  }
  const sortSubInspectionNotes = (notes, structureUnits) => {
    const abutmentSortOrder = ["NAB", "FAB"];
    const selectedStructureUnits = structureUnits ?? inspectionStore.selectedInspection.structureUnits;
    const getStrUnit = (note) => {
      if (!note) return null;
      const subStructure = selectedStructureUnits.find(
        (u) => Number.parseInt(u.structureUnitId) === Number.parseInt(note.structureUnitId)
      );
      return inspectionStore.getSubStructure(subStructure?.strUnitKey, structureUnits);
    };
    notes?.sort((a, b) => {
      const strUnitA = getStrUnit(a);
      const strUnitB = getStrUnit(b);
      if (abutmentSortOrder?.includes(strUnitA?.strUnitLabel) && abutmentSortOrder?.includes(strUnitB?.strUnitLabel)) {
        return abutmentSortOrder?.indexOf(strUnitA?.strUnitLabel) - abutmentSortOrder?.indexOf(strUnitB?.strUnitLabel);
      }
      // If only one element is in the custom order, it comes first
      if (abutmentSortOrder?.includes(strUnitA?.strUnitLabel)) {
        return -1;
      }
      if (abutmentSortOrder?.includes(strUnitB?.strUnitLabel)) {
        return 1;
      }
      const strUnitLabelA = strUnitA?.strUnitLabel?.toString();
      const strUnitLabelB = strUnitB?.strUnitLabel?.toString();
      const parsedLabelA = parseStrUnitLabel(strUnitLabelA);
      const parsedLabelB = parseStrUnitLabel(strUnitLabelB);
      if (parsedLabelA.prefix !== parsedLabelB.prefix) {
        return parsedLabelA.prefix.localeCompare(parsedLabelB.prefix);
      }
      return parsedLabelA.number - parsedLabelB.number;
    });
  };

  return {
    noteTypeIN01,
    substuctureUnitIN03,
    noteTypeIN04,
    sortSubInspectionNotes,
    parseStrUnitLabel,
  };
};
